/**
 *  Vuex Rest API
 *
 *  @model Sim
 */
import Vapi from 'vuex-rest-api'
import apiConfig from '@/config/api'
import { axiosInstance } from '../../plugins/axios'

/**
 *  Devices on REST API
 */
export default new Vapi({
  axios: axiosInstance,
  baseURL: apiConfig.url,
  state: {
    sim: {},
    sims: {}
  }
}).get({
  action: 'getSim',
  property: 'sim',
  path: ({ id }) => `/sims/${id}`
}).get({
  action: 'getSims',
  property: 'sims',
  path: 'sims'
}).put({
  action: 'updateSim',
  property: 'sim',
  path: ({ id }) => `/sims/${id}`
}).post({
  action: 'createSim',
  property: 'sim',
  path: '/sims'
}).delete({
  action: 'deleteSim',
  property: 'sim',
  path: ({ id }) => `/sims/${id}`
}).delete({
  action: 'deleteSims',
  property: 'sim',
  path: ({ sim_ids }) => '/sims'
}).getStore({
  namespaced: true,
  createStateFn: true
})
